import { Route } from 'react-router-dom';
import Guidance from 'pages/guidance';
import HemodynamicGuidance from "modules/intensiveCare/components/Guidance/HemodynamicGuidance";
import Drugs from 'pages/drugs';
import * as drugsData from 'config/data';
import Drug from 'pages/drug';
import DrugType from 'modules/intensiveCare/models/DrugType';

const Hemodynamic = [
    <Route
      exact
      path="/hemodynamic/guidance"
      key="/hemodynamic/guidance"
      render={() => <Guidance title="Hemodinâmica"><HemodynamicGuidance /></Guidance>}
    />,
    <Route
      exact
      path="/hemodynamic/drugs/"
      key="/hemodynamic/drugs/"
      render={({ match }) => <Drugs
        title="Hemodinâmica"
        subtitle="Drogas"
        drugs={drugsData.vasoactive}
        path={match.path}
      />}
    />,
    <Route 
      exact 
      path="/hemodynamic/drugs/:drugKey"
      key="/hemodynamic/drugs/:drugKey"
      render={props => <Drug drugType={DrugType.VASOACTIVE} drugId={props.match.params.drugKey} />}
    />,
];

export default Hemodynamic;
